import { render } from "./FormOptions.vue?vue&type=template&id=d4be512e&ts=true"
import script from "./FormOptions.vue?vue&type=script&lang=ts"
export * from "./FormOptions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__